import React from "react";
import _ from "lodash";
import { Button, Text } from "@showitinc/showit-wc";
import DomainSelectorHeader from "../../../components/DomainSelectorHeader";
import SiteSettingsActions from "../../../actions/SiteSettingsActions";
import DomainSettingsActions from "../../../actions/DomainSettingsActions";
import UIActions from "../../../actions/UIActions";
import AppConstants from "../../../constants/AppConstants";
import DomainSelector from "../../../components/DomainSelector";
import SubscribeButton from "../../../components/SubscribeButton";
import styles from "./DomainView.module.css";

const DomainView = ({ siteSettings, onChange, showChangesDialog, isSubscribed }) => {
  const currentDomainId = siteSettings.getIn(["site", "site_domain_id"]);

  const _onConfigureDomain = (domain) => {
    SiteSettingsActions.closeDialog();
    DomainSettingsActions.editSettings(domain);
    UIActions.modalOpen(AppConstants.MODAL_DOMAIN_SETTINGS);
  };

  const _updateSiteDomain = (propInfo) => {
    const updatedPropInfo = {
      ...propInfo,
      action: AppConstants.UPDATE_ACTION_SET,
    };
    onChange(updatedPropInfo);
  };

  const _showAddSubdomainForm = () => {
    showChangesDialog(() => {
      SiteSettingsActions.toggleSubdomainAdd({ open: true });
    });
  };

  let domainSettings = null;
  let hasDomains = false;
  const domainList = siteSettings.get("domainList");
  if (domainList.loaded) {
    hasDomains = domainList.domains.length > 0;

    const selectedDomain = _.find(domainList.domains, { site_id: currentDomainId });
    if (selectedDomain) {
      domainSettings = (
        <DomainSelectorHeader
          domain={selectedDomain}
          onConfigureClick={() => _onConfigureDomain(selectedDomain)}
        />
      );
    }
  }

  return (
    <div className={styles.container}>
      {isSubscribed ? (
        <>
           <Text variant="heading-3">
            Any changes you make will require you to republish your site.
          </Text>
          {domainSettings}
          <DomainSelector
            propName="site.site_domain_id"
            height="18.75rem"
            value={currentDomainId}
            onChange={_updateSiteDomain}
            showSetupOnEmptyList
          />
          <div className={`${styles.addSubdomain} ${hasDomains ? styles.addSubdomainVisible : ""}`}>
            <Button
              variant="outline"
              onClick={_showAddSubdomainForm}
              data-testid="add-subdomain-button"
            >
              Add +Site subdomain
            </Button>
          </div>
        </>
      ) : (
        <>
          <div className={styles.needDomain}>Need to add a domain? No problem.</div>
          <div className={styles.centered}>
            <SubscribeButton>Subscribe Now</SubscribeButton>
          </div>
        </>
      )}
    </div>
  );
};

export default DomainView;
